module.exports = __webpack_public_path__ + "img/cuba.be02b780.svg";